import { render, staticRenderFns } from "./EditorsFileUploader.vue?vue&type=template&id=788e464e&"
import script from "./EditorsFileUploader.vue?vue&type=script&lang=js&"
export * from "./EditorsFileUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports